import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { InputWrapBodyDirective } from '../../../../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../../../../ui/form/input-wrap.component';
import { MuiInputDirective } from '../../../../../ui/form/mui-input.directive';

export interface IKlarnaCalculation {
    monthPayment: number;
    lastPayment: number;
    total: number;
}

export interface PageComponentKlarnaCalculatorComponentData extends NICmsContentComponent.IData {
    min_value: number;
    title: string;
    subtitle?: string;
}
@ICmsComponent<PageComponentKlarnaCalculatorComponent>({
    id: 'klarna-calculator',
    name: 'Klarna Calculator',
    tags: ['Homepage', 'Klarna', 'Calculator'],
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            required: true,
            default: 'Lorem ipsum'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'subtitle',
            title: 'Subtitle'
        },
        {
            type: NICmsContentField.EFieldType.number,
            key: 'min_value',
            title: 'Minimum value',
            required: true,
            default: 300
        }
    ]
})
@Component({
    selector: 'page-component-klarna-calculator',
    templateUrl: './klarna-calculator.html',
    standalone: true,
    imports: [FormsModule, ICmsClientModule, InputWrapBodyDirective, InputWrapComponent, MuiInputDirective, PriceComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentKlarnaCalculatorComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: PageComponentKlarnaCalculatorComponentData;

    form?: NgForm;
    basketValue?: number;
    calculation?: IKlarnaCalculation;

    get minValue(): number {
        return this.component?.min_value || 0;
    }

    updateCalculation(value: number | string) {
        if (typeof value === 'string') {
            value = parseFloat(value);
        }
        if (value && value >= this.minValue) {
            if ((value * 100) % 1 === 0) {
                const monthPayment = Math.ceil((value / 12) * 100) / 100;
                const lastPayment = Math.round((value - monthPayment * 11 + 0.00001) * 100) / 100;
                this.calculation = {
                    monthPayment,
                    lastPayment,
                    total: value
                };
            }
        } else {
            this.calculation = undefined;
        }

        this.detectChanges();
    }
}
